module.exports = __webpack_public_path__ + "072a270ac99cf59255dc10efa7df1472.pdf";